<script setup>
/* Sprachwahl in der Kopfleiste. */

import { useI18n } from 'vue-i18n';
import DropdownMenu from './DropdownMenu.vue';
import { SUPPORTED_LOCALES, persistLocale } from '../i18n/index.js';

const { locale } = useI18n();

function choose(code, close) {
  locale.value = code;
  persistLocale(code);
  close();
}
</script>

<template>
  <DropdownMenu align="right" :width="176">
    <template #trigger="{ toggle }">
      <button class="login-status lang-trigger" :title="$t('settings.language')" @click="toggle">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
          <circle cx="12" cy="12" r="9" />
          <path d="M3 12h18M12 3c2.5 2.6 3.8 5.6 3.8 9s-1.3 6.4-3.8 9c-2.5-2.6-3.8-5.6-3.8-9S9.5 5.6 12 3z" />
        </svg>
        <span>{{ locale.toUpperCase() }}</span>
      </button>
    </template>

    <template #default="{ close }">
      <button
        v-for="l in SUPPORTED_LOCALES"
        :key="l.code"
        class="dd-item"
        :class="{ active: locale === l.code }"
        @click="choose(l.code, close)"
      >
        <span class="lang-code">{{ l.code.toUpperCase() }}</span>
        <span class="dd-label">{{ l.label }}</span>
        <svg
          v-if="locale === l.code"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.2"
        >
          <path d="M4 12.5l5 5L20 6.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </button>
    </template>
  </DropdownMenu>
</template>

<style scoped>
.lang-trigger {
  gap: 7px;
}
.lang-code {
  flex: none;
  width: 22px;
  font-size: 0.66rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  color: var(--dim);
}
.dd-item.active .lang-code {
  color: var(--green);
}
</style>
